var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.attributes.length ||
      (_vm.possibleUnitCombinationIds.length > 1 && _vm.isContentVisible)
        ? [
            _vm._l(_vm.attributes, function(attribute, index) {
              return _c(
                "div",
                { key: index, staticClass: "col-12 variation-select" },
                [
                  attribute.type === "dropdown"
                    ? _c(
                        "div",
                        {
                          ref: "attributesContaner",
                          refInFor: true,
                          staticClass: "input-unit",
                          staticStyle: { overflow: "visible" }
                        },
                        [
                          _c(
                            "select",
                            {
                              staticClass: "custom-select",
                              attrs: {
                                id: "custom-select_" + attribute.name,
                                "data-testing": "variation-select-dropdown"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectAttribute(
                                    attribute.attributeId,
                                    $event.target.value
                                  )
                                }
                              }
                            },
                            [
                              _vm.addPleaseSelectOption || !_vm.hasSelection
                                ? _c("option", { domProps: { value: -1 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemPleaseSelect"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasEmptyOption ||
                              _vm.selectedAttributes[attribute.attributeId] ===
                                null
                                ? _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: null,
                                        selected:
                                          _vm.selectedAttributes[
                                            attribute.attributeId
                                          ] === null
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemNoSelection"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(attribute.values, function(value) {
                                return _c(
                                  "option",
                                  {
                                    key: value.attributeValueId,
                                    domProps: {
                                      value: value.attributeValueId,
                                      selected:
                                        value.attributeValueId ===
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ]
                                    }
                                  },
                                  [
                                    _vm.isAttributeSelectionValid(
                                      attribute.attributeId,
                                      value.attributeValueId,
                                      true
                                    )
                                      ? [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(value.name) +
                                              "\n                        "
                                          )
                                        ]
                                      : _vm.isAttributeSelectionValid(
                                          attribute.attributeId,
                                          value.attributeValueId,
                                          false
                                        )
                                      ? [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemNotSalableAttribute",
                                                  { name: value.name }
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemInvalidAttribute",
                                                  { name: value.name }
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                  ],
                                  2
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.isTextCut(attribute.name),
                                  expression: "isTextCut(attribute.name)"
                                }
                              ],
                              attrs: {
                                for: "custom-select_" + attribute.name,
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                                title: attribute.name,
                                "data-testing":
                                  "variation-select-dropdown-label"
                              }
                            },
                            [_vm._v(_vm._s(attribute.name))]
                          )
                        ]
                      )
                    : attribute.type === "box" || attribute.type === "image"
                    ? _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "text-muted color-gray-700",
                            attrs: { "data-testing": "attribute-name" }
                          },
                          [_vm._v(_vm._s(attribute.name) + ":")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b",
                          { attrs: { "data-testing": "attribute-value" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getSelectedAttributeValueName(attribute)
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "v-s-boxes py-3",
                            class: { images: attribute.type === "image" }
                          },
                          [
                            _vm.addPleaseSelectOption
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "v-s-box bg-white empty-option",
                                    class: {
                                      active:
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ] === -1,
                                      invalid: !_vm.isAttributeSelectionValid(
                                        attribute.attributeId,
                                        -1
                                      )
                                    },
                                    attrs: {
                                      tabindex: "0",
                                      "data-testing": "variation-select-box"
                                    },
                                    on: {
                                      keydown: _vm.handleKeydown,
                                      click: function($event) {
                                        return _vm.selectAttribute(
                                          attribute.attributeId,
                                          -1
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "mx-3" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemPleaseSelect"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasEmptyOption
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "v-s-box bg-white empty-option",
                                    class: {
                                      active:
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ] === null,
                                      invalid: !_vm.isAttributeSelectionValid(
                                        attribute.attributeId,
                                        null,
                                        true
                                      )
                                    },
                                    attrs: {
                                      tabindex: "0",
                                      "data-testing": "variation-select-box"
                                    },
                                    on: {
                                      keydown: _vm.handleKeydown,
                                      click: function($event) {
                                        return _vm.selectAttribute(
                                          attribute.attributeId,
                                          null
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "mx-3" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemNoSelection"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(attribute.values, function(value) {
                              return _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: true,
                                      expression: "true"
                                    }
                                  ],
                                  key: value.attributeValueId,
                                  staticClass: "v-s-box bg-white",
                                  class: {
                                    active:
                                      value.attributeValueId ===
                                      _vm.selectedAttributes[
                                        attribute.attributeId
                                      ],
                                    invalid: !_vm.isAttributeSelectionValid(
                                      attribute.attributeId,
                                      value.attributeValueId,
                                      true
                                    )
                                  },
                                  attrs: {
                                    tabindex: "0",
                                    "data-testing": "variation-select-box",
                                    "data-html": "true",
                                    "data-toggle": "tooltip",
                                    "data-placement": "top",
                                    "data-original-title": _vm.getTooltip(
                                      attribute,
                                      value
                                    )
                                  },
                                  on: {
                                    keydown: _vm.handleKeydown,
                                    click: function($event) {
                                      return _vm.selectAttribute(
                                        attribute.attributeId,
                                        value.attributeValueId
                                      )
                                    }
                                  }
                                },
                                [
                                  attribute.type === "box"
                                    ? _c("span", { staticClass: "mx-3" }, [
                                        _vm._v(_vm._s(value.name))
                                      ])
                                    : _c("img", {
                                        staticClass: "p-1",
                                        attrs: {
                                          src: value.imageUrl,
                                          alt: value.name
                                        }
                                      })
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e()
                ]
              )
            }),
            _vm._v(" "),
            _vm.possibleUnitCombinationIds.length > 1 && _vm.isContentVisible
              ? _c("div", { staticClass: "col-12 variation-select" }, [
                  _c("div", { staticClass: "input-unit" }, [
                    _c(
                      "select",
                      {
                        staticClass: "custom-select",
                        attrs: {
                          id: "unit-combination-ids-select",
                          "data-testing": "variation-select-unit"
                        },
                        on: {
                          change: function($event) {
                            return _vm.selectUnit($event.target.value)
                          }
                        }
                      },
                      _vm._l(_vm.possibleUnitCombinationIds, function(
                        unitCombinationId
                      ) {
                        return _c(
                          "option",
                          {
                            key: unitCombinationId,
                            domProps: {
                              value: unitCombinationId,
                              selected:
                                parseInt(unitCombinationId) === _vm.selectedUnit
                            }
                          },
                          [
                            _vm.isUnitSelectionValid(unitCombinationId)
                              ? [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.possibleUnits[unitCombinationId]
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemInvalidAttribute",
                                          {
                                            name:
                                              _vm.possibleUnits[
                                                unitCombinationId
                                              ]
                                          }
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                          ],
                          2
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: {
                          for: "unit-combination-ids-select",
                          "data-testing": "variation-select-unit-label"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.singleItemContent")
                          )
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ]
        : [_vm._t("default")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }